// DE UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'Apartments und Hotels',
  'site.currency': 'Währung',
  'site.language': 'Sprache',
  'site.currencySelector': 'Währung auswählen',
  'site.languageSelector': 'Sprache auswählen',
  'site.menu': 'Menü',
  'site.signIn': 'Anmelden',
  'site.signOut': 'Abmelden',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'Menü öffnen',
  'site.footer.copyright': 'Alle Rechte vorbehalten.',
  'site.footer.manageBooking': 'Buchung verwalten',
  'site.footer.terms': 'AGB',
  'site.footer.privacy': 'Datenschutz',
  'site.trust.bestPrice': 'Bestpreis-Garantie',
  'site.trust.bestPriceDesc': 'Die besten Preise.',
  'site.trust.flexibleBooking': 'Flexible Buchung',
  'site.trust.flexibleBookingDesc': 'Einfache Änderungen & Stornierungen.',
  'site.trust.securePayments': 'Sichere Zahlungen',
  'site.trust.securePaymentsDesc': 'Vertrauenswürdig & sicher.',
  'site.trust.localSupport': 'Lokaler Support',
  'site.trust.localSupportDesc': 'Wir sind jederzeit für Sie da.',
  'home.heroTitle': 'Finde deinen perfekten Aufenthalt',
  'home.inAustralia': 'in Australien',
  'home.heroSubtitle': 'Apartments und Hotels für jede Art von Aufenthalt',
  'home.errorLoading': 'Unterkünfte konnten nicht geladen werden.',
  'home.noPropertiesTitle': 'Derzeit sind keine Unterkünfte verfügbar.',
  'home.noPropertiesDescription': 'Suche nach einem Ziel, um verfügbare Aufenthalte zu entdecken.',
  'home.exploreStays': 'Aufenthalte entdecken',
  'home.property': 'Unterkunft',
  'home.property_one': 'Unterkunft',
  'home.property_other': 'Unterkünfte',
  'home.properties': 'Unterkünfte',
  'home.foundInAustralia': 'in Australien gefunden',
  'search.errorLoading': 'Verfügbarkeit konnte nicht geladen werden. Bitte versuche es erneut.',
  'search.noResults': 'Keine Unterkünfte entsprechen deinen Suchkriterien.',
  'search.mapFollow': 'Mit Karte bewegen suchen',
  'search.chooseLocationTitle': 'Wähle einen Ort',
  'search.chooseLocationDescription':
    'Wähle ein Ziel, bevor du nach verfügbaren Aufenthalten suchst.',
  'search.chooseDatesTitle': 'Wähle deine Daten',
  'search.pastCheckIn': 'Der Check-in darf nicht in der Vergangenheit liegen.',
  'search.checkOutAfterCheckIn': 'Der Check-out muss nach dem Check-in liegen.',
  'search.property': 'Unterkunft',
  'search.property_one': 'Unterkunft',
  'search.property_other': 'Unterkünfte',
  'search.properties': 'Unterkünfte',
  'search.found': 'gefunden',
  'widget.where': 'Wo',
  'widget.location': 'Ort',
  'widget.checkInOut': 'Check-in / Check-out',
  'widget.guests': 'Gäste',
  'widget.rooms': 'Zimmer',
  'widget.promoCode': 'Promo-Code',
  'widget.promoPlaceholderCompact': 'Code hinzufügen (optional)',
  'widget.promoPlaceholder': 'Optional',
  'widget.search': 'Suchen',
  'widget.update': 'Aktualisieren',
  'widget.adult': 'Erwachsener',
  'widget.adults': 'Erwachsene',
  'widget.child': 'Kind',
  'widget.children': 'Kinder',
  'widget.decreaseAdults': 'Erwachsene verringern',
  'widget.increaseAdults': 'Erwachsene erhöhen',
  'widget.decreaseChildren': 'Kinder verringern',
  'widget.increaseChildren': 'Kinder erhöhen',
  'widget.room': 'Zimmer',
  'widget.adultOption': '{count} Erwachsene',
  'widget.adultOption_one': '{count} Erwachsener',
  'widget.adultOption_other': '{count} Erwachsene',
  'widget.childOption': '{count} Kinder',
  'widget.childOption_one': '{count} Kind',
  'widget.childOption_other': '{count} Kinder',
  'widget.roomOption': '{count} Zimmer',
  'widget.roomOption_one': '{count} Zimmer',
  'widget.roomOption_other': '{count} Zimmer',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': 'Orte konnten nicht geladen werden. Bitte versuche es erneut.',
  'widget.searchAria': 'Verfügbarkeit suchen',
  'widget.dateErrorRequired': 'Bitte wähle Check-in und Check-out.',
  'widget.dateErrorPast': 'Der Check-in darf nicht in der Vergangenheit liegen.',
  'widget.dateErrorRange': 'Der Check-out muss nach dem Check-in liegen.',
  'widget.dateRange.placeholder': 'Check-in- & Check-out-Datum wählen',
  'widget.dateRange.selectCheckout': 'Check-out auswählen',
  'widget.dateRange.aria.checkIn': 'Check-in',
  'widget.dateRange.aria.checkOut': 'Check-out',
  'widget.dateRange.aria.picker': 'Check-in- / Check-out-Datumsauswahl',
  'widget.dateRange.previousMonth': 'Vorheriger Monat',
  'widget.dateRange.nextMonth': 'Nächster Monat',
  'widget.dateRange.selectCheckIn': 'Check-in-Datum auswählen',
  'widget.dateRange.selectCheckOut': 'Check-out-Datum auswählen',
  'widget.dateRange.resetToday': 'Auf heute zurücksetzen',
  'widget.dateRange.done': 'Fertig',
  'property.heroAlt': 'Unterkunft',
  'property.fallbackName': 'Ausgewählte Unterkunft von {site}',
  'property.chooseRoom': 'Wähle dein Zimmer',
  'property.filterBy': 'Filtern nach:',
  'property.filterAll': 'Alle Zimmer',
  'property.filterStudios': 'Studios',
  'property.filter1Bed': '1 Schlafzimmer',
  'property.filter2Bed': '2 Schlafzimmer',
  'property.filterApartments': 'Apartments',
  'property.sortBy': 'Sortieren nach:',
  'property.sortRecommended': 'Empfohlen',
  'property.sortPriceLow': 'Preis: niedrig nach hoch',
  'property.sortPriceHigh': 'Preis: hoch nach niedrig',
  'property.errorLoading': 'Verfügbarkeit konnte nicht geladen werden. Bitte versuche es erneut.',
  'property.noRooms': 'Keine Zimmer verfügbar',
  'property.noRoomsDescription': 'Probiere andere Daten oder Gäste.',
  'property.totalForNights': 'Gesamt für {nights} Nächte',
  'property.perNight': 'pro Nacht',
  'property.night': 'Nacht',
  'property.night_one': 'Nacht',
  'property.night_other': 'Nächte',
  'property.nights': 'Nächte',
  'property.freeCancellation': 'Kostenlose Stornierung',
  'property.selectRoom': 'Zimmer auswählen',
  'property.selected': 'Ausgewählt',
  'property.continue': 'Weiter',
  'property.previousPhoto': 'Vorheriges Foto',
  'property.nextPhoto': 'Nächstes Foto',
  'property.addToWishlist': 'Zur Wunschliste hinzufügen',
  'property.popularChoice': 'Beliebte Wahl',
  'property.showMore': 'Mehr anzeigen',
  'property.showLess': 'Weniger anzeigen',
  'property.maxOccupancy': 'Max. Belegung:',
  'property.size': 'Größe:',
  'property.bedType': 'Bettentyp:',
  'property.roomAmenities': 'Zimmerausstattung',
  'property.showMoreAmenities': '+{count} weitere',
  'property.guests': 'Gäste',
  'property.adults': 'Erwachsene',
  'property.children': 'Kinder',
  'property.onlyRoomsLeft': 'Nur noch {count} Zimmer übrig',
  'property.onlyRoomsLeft_one': 'Nur noch {count} Zimmer übrig',
  'property.onlyRoomsLeft_other': 'Nur noch {count} Zimmer übrig',
  'property.lastBookedMinutes': 'Zuletzt vor {count} Minuten gebucht',
  'property.lastBookedMinutes_one': 'Zuletzt vor {count} Minute gebucht',
  'property.lastBookedMinutes_other': 'Zuletzt vor {count} Minuten gebucht',
  'property.lastBookedHours': 'Zuletzt vor {count} Stunden gebucht',
  'property.lastBookedHours_one': 'Zuletzt vor {count} Stunde gebucht',
  'property.lastBookedHours_other': 'Zuletzt vor {count} Stunden gebucht',
  'property.lastBookedDays': 'Zuletzt vor {count} Tagen gebucht',
  'property.lastBookedDays_one': 'Zuletzt vor {count} Tag gebucht',
  'property.lastBookedDays_other': 'Zuletzt vor {count} Tagen gebucht',
  'property.checkInTime': 'Check-in {time}',
  'property.checkOutTime': 'Check-out {time}',
  'property.compare': 'Vergleichen',
  'property.taxesIncluded': 'pro Nacht inkl. Steuern & Gebühren',
  'property.chooseRate': 'Wähle deine Rate',
  'property.yourSelection': 'Deine Auswahl',
  'property.aboutRoom': 'Über dieses Zimmer',
  'property.roomDetails': 'Zimmerdetails',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': 'Zurück zu den Zimmern',
  'property.standardRate': 'Standardtarif',
  'property.noPromotion': 'Für diese Rate ist keine Aktion verfügbar.',
  'property.youSave': 'Du sparst ({percent}% Rabatt) - {amount}',
  'property.inclusions': 'Inklusivleistungen:',
  'property.viewAllPhotos': 'Alle Fotos anzeigen',
  'property.seeOnMap': 'Auf Karte anzeigen',
  'room.perNight': 'Nacht',
  'room.sleeps': 'Schlafplätze',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': 'verfügbar',
  'room.select': 'Auswählen',
  'room.selected': 'Ausgewählt',
  'card.viewAvailability': 'Verfügbarkeit anzeigen',
  'card.from': 'Ab',
  'card.night': 'Nacht',
  'card.checkAvailability': 'Verfügbarkeit prüfen',
  'card.saveToFavourites': 'Zu Favoriten hinzufügen',
  'card.ratingExcellent': 'Hervorragend',
  'card.ratingVeryGood': 'Sehr gut',
  'card.ratingGood': 'Gut',
  'card.ratingGuest': 'Gästebewertung',
  'guest.stepChooseRoom': 'Zimmer wählen',
  'guest.stepGuestDetails': 'Gästedaten',
  'guest.stepPayment': 'Zahlung',
  'guest.stepConfirmation': 'Bestätigung',
  'guest.title': 'Gästedaten eingeben',
  'guest.subtitle': 'Bitte gib deine Daten ein.',
  'guest.firstName': 'Vorname',
  'guest.lastName': 'Nachname',
  'guest.email': 'E-Mail',
  'guest.emailHint': 'Die Buchungsbestätigung wird an diese E-Mail gesendet.',
  'guest.country': 'Land',
  'guest.selectCountry': 'Land auswählen',
  'guest.searchCountry': 'Länder suchen…',
  'guest.loadingCountries': 'Länder werden geladen…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': 'Postleitzahl',
  'guest.phone': 'Telefonnummer',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': 'Telefonnummer eingeben',
  'guest.address': 'Adresse',
  'guest.city': 'Stadt',
  'guest.specialRequests': 'Besondere Wünsche (optional)',
  'guest.specialRequestsPlaceholder': 'Besondere Wünsche?',
  'guest.termsPrefix': 'Mit Abschluss dieser Buchung stimme ich den',
  'guest.terms': 'AGB',
  'guest.termsAnd': 'und',
  'guest.privacy': 'Datenschutzbestimmungen',
  'guest.termsSuffix': 'zu und akzeptiere die Buchungsbedingungen.',
  'guest.marketingOptOut': 'Ich möchte keine Marketing-Nachrichten erhalten.',
  'guest.cardVerify':
    'Eine vorläufige Kartenprüfung über 1 {currency} wird vorgenommen. Du wirst jetzt nicht belastet.',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'Die Zahlung erfolgt vor Ort.',
  'guest.noRoomsSelected': 'Keine Zimmer ausgewählt.',
  'guest.noPropertySelected': 'Keine Unterkunft ausgewählt.',
  'guest.paymentStillLoading':
    'Zahlungsoptionen werden noch geladen. Bitte versuche es gleich erneut.',
  'guest.submitProcessing': 'Wird bearbeitet…',
  'guest.submitVerifyCard': 'Karte prüfen & Buchung bestätigen',
  'guest.submitConfirm': 'Buchung bestätigen',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'Zahlung',
  'payment.method': 'Zahlungsmethode',
  'payment.cardDetailsHint':
    'Gib deine Kartendaten sicher unten ein. Sie werden tokenisiert und berühren nie unsere Server.',
  'payment.loadingForm': 'Zahlungsformular wird geladen…',
  'payment.formUnavailable': 'Zahlungsformular nicht verfügbar.',
  'payment.acceptTerms': 'Ich akzeptiere die AGB und die Stornierungsbedingungen.',
  'payment.payNow': 'Jetzt zahlen',
  'payment.processing': 'Wird bearbeitet…',
  'payment.noRoomsSelected': 'Keine Zimmer ausgewählt.',
  'payment.redirecting': 'Weiterleitung zur sicheren Zahlungsseite…',
  'payment.notConfigured': 'Quickstream ist für diese Unterkunft nicht konfiguriert.',
  'payment.noScript': 'Quickstream konnte nicht geladen werden. Bitte aktualisiere die Seite.',
  'payment.formNotLoaded': 'Zahlungsformular nicht geladen. Bitte aktualisiere die Seite.',
  'payment.cardDetails': 'Zahlung fehlgeschlagen. Bitte überprüfe deine Kartendaten.',
  'payment.tokenizationFailed': 'Kartentokenisierung fehlgeschlagen. Bitte versuche es erneut.',
  'payment.failed': 'Zahlung fehlgeschlagen.',
  'payment.statusResult': 'Zahlungsstatus: {status}. Bitte versuche es erneut.',
  'confirmation.loading': 'Buchung wird geladen…',
  'confirmation.notFound': 'Buchung nicht gefunden. Überprüfe deine Buchungsreferenz.',
  'confirmation.errorGeneric':
    'Buchung konnte nicht bestätigt werden. Bitte kontaktiere den Support.',
  'confirmation.errorLoadDetails': 'Buchungsdetails konnten nicht geladen werden.',
  'confirmation.couldNotComplete': 'Wir konnten deine Zahlung nicht abschließen',
  'confirmation.startNew': 'Neue Buchung starten',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound':
    'Zahlungssitzung konnte nicht gefunden werden. Bitte kontaktiere den Support.',
  'confirmation.paymentStateInvalid':
    'Die Zahlung kann nicht abgeschlossen werden. Bitte starte erneut.',
  'confirmation.paymentFailedDeclined':
    'Die Zahlung konnte nicht abgeschlossen werden. Bitte überprüfe deine Kartendaten und versuche es erneut, oder nutze eine andere Zahlungsmethode.',
  'confirmation.paymentTimeout': 'Die Zahlung dauerte zu lange. Bitte versuche es erneut.',
  'confirmation.paymentGatewayUnavailable':
    'Das Zahlungssystem ist vorübergehend nicht verfügbar. Bitte versuche es in wenigen Augenblicken erneut.',
  'confirmation.paymentUnknown': 'Zahlung konnte nicht bestätigt werden: {message}.',
  'confirmation.paymentGenericError':
    'Zahlung konnte nicht bestätigt werden. Bitte versuche es erneut oder kontaktiere den Support.',
  'summary.title': 'Deine Buchungsübersicht',
  'summary.yourBooking': 'Deine Buchungsübersicht',
  'summary.noRoomsSelected': 'Noch keine Zimmer ausgewählt.',
  'summary.checkIn': 'CHECK-IN',
  'summary.checkOut': 'CHECK-OUT',
  'summary.lengthOfStay': 'Aufenthaltsdauer',
  'summary.guests': 'Gäste',
  'summary.nights': '{nights} Nächte',
  'summary.nights_one': '{nights} Nacht',
  'summary.nights_other': '{nights} Nächte',
  'summary.totalForNights': 'Gesamt für {nights} Nächte',
  'summary.includingTaxes': 'Inklusive Steuern & Gebühren',
  'summary.discount': 'Du sparst {amount}',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': 'Buchung bestätigt!',
  'detail.received': 'Buchung erhalten',
  'detail.referenceIntro': 'Deine Buchungsreferenz ist',
  'detail.reservationId': 'Reservierungs-ID:',
  'detail.processing':
    'Deine Buchung wird bearbeitet. Du erhältst eine E-Mail, sobald die Zahlung bestätigt ist.',
  'detail.guest': 'Gast',
  'detail.rooms': 'Zimmer',
  'detail.night': 'Nacht',
  'detail.nights': 'Nächte',
  'detail.adult': 'Erwachsener',
  'detail.adults': 'Erwachsene',
  'detail.child': 'Kind',
  'detail.infant': 'Baby',
  'detail.priceBreakdown': 'Preisaufschlüsselung',
  'detail.subtotal': 'Zwischensumme',
  'detail.taxes': 'Steuern',
  'detail.fees': 'Gebühren',
  'detail.discounts': 'Rabatte',
  'detail.surcharge': 'Kartenzuschlag',
  'detail.grandTotal': 'Gesamtsumme',
  'priceBreakdown.roomSubtotal': 'Zimmer-Zwischensumme',
  'priceBreakdown.total': 'Gesamt',
  'detail.deposit': 'Anzahlung',
  'detail.depositDueBy': 'fällig bis',
  'detail.arrival': 'Anreise',
  'detail.specialRequests': 'Besondere Wünsche',
  'detail.backToHome': 'Zurück zur Startseite',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': 'Erneut versuchen',
  'shared.close': 'Schließen',
  'shared.back': 'Zurück',
  'shared.previous': 'Vorheriges',
  'shared.next': 'Nächstes',
  'validation.firstNameRequired': 'Vorname ist erforderlich',
  'validation.lastNameRequired': 'Nachname ist erforderlich',
  'validation.emailRequired': 'Gültige E-Mail ist erforderlich',
  'validation.phoneRequired': 'Telefonnummer ist erforderlich',
  'validation.addressRequired': 'Adresse ist erforderlich',
  'validation.cityRequired': 'Stadt ist erforderlich',
  'validation.countryRequired': 'Land ist erforderlich',
  'validation.postalCodeRequired': 'Postleitzahl ist erforderlich',
  'error.pmsUnavailable':
    'Dieses Zimmer ist für deine gewählten Daten leider nicht mehr verfügbar. Bitte gehe zurück und wähle andere Daten oder ein anderes Zimmer.',
  'error.pmsSyncError':
    'Wir konnten keine Verbindung zum Unterkunftssystem herstellen. Bitte versuche es in wenigen Augenblicken erneut.',
  'error.paymentNotConfigured':
    'Für diese Unterkunft ist keine Zahlung eingerichtet. Bitte wähle eine andere Unterkunft oder kontaktiere den Support.',
  'error.paymentStartFailed':
    'Beim Starten der Zahlung ist etwas schiefgelaufen. Bitte versuche es erneut.',
  'error.bookingFailed': 'Buchung fehlgeschlagen. Bitte versuche es erneut.',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': 'Deinen Aufenthalt buchen',
  'site.title.suffix': 'Apartments und Hotels',
  'site.title.home': 'Startseite',
  'site.title.search': 'Suche',
  'site.title.property': 'Unterkunft',
  'site.title.room': 'Zimmer',
  'site.title.guestDetails': 'Gästedaten',
  'site.title.payment': 'Zahlung',
  'site.title.confirmation': 'Buchung bestätigt',
  'site.title.bookingLookup': 'Buchung finden',
  'site.title.bookingDetails': 'Buchungsdetails',
  'site.title.cancellation': 'Buchung stornieren',
  'site.title.reservationDetail': 'Reservierungsdetails',
  'site.title.signIn': 'Anmelden',
  'site.title.signUp': 'Registrieren',
  'site.title.notFound': 'Seite nicht gefunden',
  'notFound.title': 'Seite nicht gefunden',
  'notFound.message': 'Die gesuchte Seite existiert nicht.',
  'notFound.backHome': 'Zurück zur Startseite',
  'home.heroAlt': 'Skyline einer australischen Stadt',
  'home.featuredProperties': 'Empfohlene Unterkünfte',
  'home.popularDestinations': 'Beliebte Reiseziele',
  'common.reviews': '{count} Bewertungen',
  'common.reviews_one': '{count} Bewertung',
  'common.reviews_other': '{count} Bewertungen',
  'common.loading': 'Wird geladen',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': 'von',
  'common.select': 'Auswählen…',
  'common.search': 'Suchen…',
  'common.selectLocation': 'Ort auswählen',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': 'Keine Optionen verfügbar',
  'common.code': 'Code',
  'common.searchCode': 'Code suchen…',
  'filter.title': 'Filter',
  'filter.price': 'Preis',
  'filter.priceMinimum': 'Minimum',
  'filter.priceMaximum': 'Maximum',
  'filter.priceMinPlaceholder': '0 €',
  'filter.priceMaxPlaceholder': '500+ €',
  'filter.propertyType': 'Unterkunftstyp',
  'filter.propertyType.hotel': 'Hotel',
  'filter.propertyType.apartment': 'Apartment',
  'filter.propertyType.resort': 'Resort',
  'filter.amenities': 'Ausstattung',
  'filter.amenity.pool': 'Pool',
  'filter.amenity.parking': 'Parkplatz',
  'filter.amenity.breakfast': 'Frühstück inklusive',
  'filter.rating': 'Bewertung',
  'filter.rating.any': 'Jede Bewertung',
  'filter.rating.5': '5 Sterne',
  'filter.rating.4': '4 Sterne und mehr',
  'filter.rating.3': '3 Sterne und mehr',
  'filter.more': 'Weitere',
  'filter.more.freeCancellation': 'Kostenlose Stornierung',
  'filter.more.payAtProperty': 'Vor Ort zahlen',
  'filter.clear': 'Zurücksetzen',
  'filter.apply': 'Filter anwenden',
  'card.reviews_one': 'Bewertung',
  'card.reviews_other': 'Bewertungen',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': 'Alter 0 – 12',
  'auth.orContinueWith': 'Oder weiter mit',
  'auth.signIn.title': 'Bei deinem Konto anmelden',
  'auth.signIn.subtitle':
    'Willkommen zurück! Melde dich an, um deine Buchungen zu verwalten, Aufenthalte anzusehen und exklusive Angebote zu erhalten.',
  'auth.email': 'E-Mail',
  'auth.emailPlaceholder': 'E-Mail-Adresse eingeben',
  'auth.emailRequired': 'E-Mail ist erforderlich.',
  'auth.emailInvalid': 'Bitte gib eine gültige E-Mail-Adresse ein.',
  'auth.password': 'Passwort',
  'auth.passwordPlaceholder': 'Passwort eingeben',
  'auth.createPasswordPlaceholder': 'Passwort erstellen',
  'auth.passwordRequired': 'Passwort ist erforderlich.',
  'auth.passwordMinLength': 'Passwort muss mindestens {min} Zeichen lang sein.',
  'auth.passwordPattern': 'Passwort muss Buchstaben und Zahlen enthalten.',
  'auth.passwordHint':
    'Verwende mindestens {min} Zeichen mit einer Mischung aus Buchstaben, Zahlen und Symbolen.',
  'auth.showPassword': 'Passwort anzeigen',
  'auth.hidePassword': 'Passwort ausblenden',
  'auth.keepSignedIn': 'Angemeldet bleiben',
  'auth.forgotPassword': 'Passwort vergessen?',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'Anmelden',
  'auth.signingIn': 'Anmeldung läuft...',
  'auth.signInError': 'Anmeldung fehlgeschlagen. Bitte versuche es erneut.',
  'auth.googleError': 'Google-Anmeldung fehlgeschlagen.',
  'auth.noAccount': 'Noch kein Konto?',
  'auth.createAccount': 'Konto erstellen',
  'auth.signUp.title': 'Dein Konto erstellen',
  'auth.signUp.subtitle':
    'Werde Mitglied bei {site}, um deine Buchungen zu verwalten, deine Lieblingsunterkünfte zu speichern und exklusive Angebote zu erhalten.',
  'auth.firstName': 'Vorname',
  'auth.firstNamePlaceholder': 'Vornamen eingeben',
  'auth.firstNameRequired': 'Vorname ist erforderlich.',
  'auth.lastName': 'Nachname',
  'auth.lastNamePlaceholder': 'Nachnamen eingeben',
  'auth.lastNameRequired': 'Nachname ist erforderlich.',
  'auth.mobile': 'Handynummer',
  'auth.mobilePlaceholder': 'Handynummer eingeben',
  'auth.dialingCode': 'Vorwahl',
  'auth.mobileRequired': 'Handynummer ist erforderlich.',
  'auth.mobileInvalid': 'Bitte gib eine gültige Handynummer ein.',
  'auth.confirmPassword': 'Passwort bestätigen',
  'auth.confirmPasswordPlaceholder': 'Passwort wiederholen',
  'auth.termsAgree': 'Ich stimme den',
  'auth.termsRequired': 'Du musst den AGB und Datenschutzbestimmungen zustimmen.',
  'auth.marketingConsent':
    'Ich möchte exklusive Angebote und Reiseinspiration von {site} erhalten.',
  'auth.signUpError': 'Konto konnte nicht erstellt werden. Bitte versuche es erneut.',
  'auth.signUp': 'Registrieren',
  'auth.creatingAccount': 'Konto wird erstellt...',
  'auth.createAccountButton': 'Konto erstellen',
  'auth.alreadyHaveAccount': 'Bereits ein Konto?',
  'auth.passwordMismatch': 'Passwörter stimmen nicht überein.',
  'pricing.title': 'Preisübersicht',
  'pricing.noRoomsSelected': 'Keine Zimmer ausgewählt. Bitte gehe zurück und wähle Zimmer aus.',
  'pricing.backToAvailability': 'Zurück zur Verfügbarkeit',
  'pricing.continue': 'Weiter zu den Gästedaten',
  'property.youSavePercent': 'Du sparst ({percent}% Rabatt)',
  'property.includingTaxesFees': '(inkl. Steuern & Gebühren)',
  'map.zoomIn': 'Vergrößern',
  'map.zoomOut': 'Verkleinern',
  'map.viewFullMap': 'In voller Karte anzeigen',
  'booking.progress': 'Buchungsfortschritt',
  'reservationDetail.resetAria': 'Buchungsstatus zurücksetzen',
  'bookingLookup.title': 'Buchung finden',
  'bookingLookup.description':
    'Gib deine Buchungsreferenz und E-Mail ein, um deine Reservierung anzusehen, zu ändern oder zu stornieren.',
  'bookingLookup.bookingReference': 'Buchungsreferenz',
  'bookingLookup.placeholder': 'z. B. SYD-260815-0001',
  'bookingLookup.lookingUp': 'Wird gesucht…',
  'bookingLookup.findBooking': 'Buchung finden',
  'bookingLookup.notFound':
    'Buchung nicht gefunden. Versuche BK-2026-001, alex.morgan@example.com und Morgan.',
  'cancellation.title': 'Buchung stornieren',
  'cancellation.property': 'Unterkunft',
  'cancellation.details': 'Stornierungsdetails',
  'cancellation.penalty': 'Stornierungsgebühr',
  'cancellation.refund': 'Rückerstattungsbetrag',
  'cancellation.totalPaid': 'Insgesamt gezahlt:',
  'cancellation.reasonLabel': 'Grund für die Stornierung (optional)',
  'cancellation.understand': 'Ich verstehe, dass dies nicht rückgängig gemacht werden kann.',
  'cancellation.cancelledDemo':
    'Deine Buchung wurde in dieser Demo-Oberfläche storniert. Rückerstattungsbetrag: {{refundAmount}}.',
  'cancellation.confirm': 'Stornierung bestätigen',
  'cancellation.notFound': 'Buchung nicht gefunden.',
  'bookingDetails.title': 'Buchungsdetails',
  'bookingDetails.notFound': 'Buchung nicht gefunden.',
  'bookingDetails.checkIn': 'Check-in:',
  'bookingDetails.checkOut': 'Check-out:',
  'bookingDetails.rooms': 'Zimmer',
  'bookingDetails.guest': 'Gast',
  'bookingDetails.freeCancellationUntil': 'Kostenlose Stornierung bis {date}',
  'bookingDetails.total': 'Gesamt:',
  'reservationDetail.loading': 'Buchung wird geladen…',
  'reservationDetail.noReference': 'Keine Buchungsreferenz angegeben.',
  'reservationDetail.loadError': 'Reservierungsdetails konnten nicht geladen werden.',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'Orte werden geladen…',
  'common.couldNotLoadLocations': 'Orte konnten nicht geladen werden',
  'common.searchLocationPlaceholder': 'Land, Stadt oder Unterkunft suchen',
  'common.collapse': 'Einklappen',
  'common.expand': 'Erweitern',
  'map.loadingGoogle': 'Google Map wird geladen…',
  'map.errorGoogle': 'Google Maps konnte nicht geladen werden',
  'map.errorMap': 'Karte konnte nicht geladen werden',
  'map.greatLocation': 'Top Lage',
  'home.trust.secureBooking': 'Sichere Buchung',
  'home.trust.secureBookingDesc': 'Deine Daten sind bei uns sicher.',
  'home.trust.bestPrice': 'Bestpreis-Garantie',
  'home.trust.bestPriceDesc': 'Günstiger gesehen? Wir gleichen es an.',
  'home.trust.localSupport': '24/7 Support',
  'home.trust.localSupportDesc': 'Wir sind jederzeit für dich da.',
  'home.trust.flexibleBooking': 'Flexible Optionen',
  'home.trust.flexibleBookingDesc': 'Kostenlose Stornierung bei ausgewählten Tarifen.',
  'promotion.memberPromo': 'Mitgliederrabatt',
  'promotion.save': 'Sparen',
  'property.memberRate': 'Mitgliedertarif',
  'property.hideAmenities': 'Ausstattung ausblenden',
  'property.showAllAmenities': 'Alle Ausstattungen anzeigen',
  'property.chooseRatePromo': 'Wähle deine bevorzugte Rate – Mitglieder sparen exklusiv!',
  'roomRate.stepChooseStay': 'Aufenthalt wählen',
  'roomRate.stepCheckout': 'Zur Kasse',
  'roomRate.stepConfirmation': 'Bestätigung',
  'roomRate.membersSaveUpTo': 'Mitglieder sparen bis zu {percent} %',
  'roomRate.membersSaveMore': 'Mitglieder sparen mehr',
  'roomRate.memberSignInHint':
    'Melde dich an oder registriere dich kostenlos beim Checkout, um Mitgliedertarife freizuschalten.',
  'roomRate.from': 'AB',
  'roomRate.perNightSuffix': '/ Nacht',
  'roomRate.nonMemberFrom': 'Nicht-Mitgliedertarif ab {price}',
  'roomRate.taxesIncluded': 'Preise inkl. Steuern & Gebühren',
  'roomRate.taxesExcluded': 'Preise exkl. Steuern & Gebühren',
  'roomRate.inclTaxes': 'inkl. Steuern & Gebühren',
  'roomRate.exclTaxes': 'exkl. Steuern & Gebühren',
  'roomRate.includesTaxes': 'Inklusive Steuern und Gebühren',
  'roomRate.excludesTaxes': 'Exklusive Steuern und Gebühren',
  'roomRate.bookNow': 'Jetzt buchen',
  'roomRate.selectRate': 'Diesen Tarif wählen',
  'roomRate.bestValue': 'Bestes Angebot',
  'roomRate.onlyLeftAtPrice': 'Nur noch {count} zu diesem Preis',
  'roomRate.fullDetails': 'Alle Zimmerdetails',
  'roomRate.loadMoreRates': 'Mehr Tarife laden',
  'roomRate.showLessRates': 'Weniger Tarife anzeigen',
  'roomRate.vsNonMemberTotal': 'statt Nicht-Mitgliedertarif {total}',
  'roomRate.youSave': 'Du sparst {amount} ({percent} % Rabatt)',
  'roomRate.totalForNights': '{total} gesamt • {nights} Nächte',
  'roomRate.nightTimes': '{nights} Nächte × {perNight}',
  'roomRate.totalLine': '{total} gesamt • {taxNote}',
  'roomRate.notMemberYet':
    'Noch kein Mitglied? Registriere dich beim Checkout – der Mitgliedertarif gilt trotzdem.',
  'roomRate.promoApplied': 'Promo {code} angewendet',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': 'Andere Zimmertypen ansehen',
  'roomRate.view': 'Ansehen',
  'roomRate.freeCancelUntil': 'Kostenlose Stornierung bis {date}',
  'roomRate.upsell': 'Empfohlene Alternative',
  'roomRate.roomsIncluded': '{count} Zimmer inklusive',
  'roomRate.nightlyBreakdown': 'Preis pro Nacht',
  'roomRate.previousRate': 'Vorheriger Tarif',
  'roomRate.nextRate': 'Nächster Tarif',
  'card.discount': '-{percent}% Rabatt',
  'gallery.imageAlt': '{title} – Ansicht {current} von {total}',
  'gallery.thumbnailAlt': 'Zu Ansicht {current} von {total}',
  'gallery.previewAlt': '{title} – Vorschau',
  'detail.night_one': 'Nacht',
  'detail.night_other': 'Nächte',
  'detail.adult_one': 'Erwachsener',
  'detail.adult_other': 'Erwachsene',
  'detail.child_one': 'Kind',
  'detail.child_other': 'Kinder',
  'detail.infant_one': 'Baby',
  'detail.infant_other': 'Babys',
} as const;
